// Stream Chat configuration
const streamChatConfig = {
	// API Key of Stream Chat - MUST be replaced with your real key
	apiKey: process.env.REACT_APP_STREAM_CHAT_API_KEY || 'your_stream_api_key_here',
	
	// Client configuration
	client: {
		// Default client configurations
		timeout: 6000,
		logger: process.env.NODE_ENV === 'development' ? console : undefined,
	},

	// Default channel configurations
	defaultChannelConfig: {
		type: 'messaging',
		options: {
			watch: true,
			state: true,
		}
	},

	// Default filters for queries
	defaultFilters: {
		channels: {
			// Only channels where the user is a member
			members: { $in: ['USER_ID_PLACEHOLDER'] }
		},
		users: {
			// Exclude blocked users, etc.
			// banned: { $ne: true }
		}
	},

	// Default sorting
	defaultSort: {
		channels: { last_message_at: -1 },
		users: { name: 1 }
	},

	// UI configuration
	ui: {
		// Default theme
		theme: 'str-chat__theme-light',
		
		// Message configuration
		message: {
			maxLength: 1000,
			allowedFileTypes: ['image/*', 'application/pdf', 'text/*'],
			maxFileSize: 10 * 1024 * 1024, // 10MB
		},

		// Channel configuration
		channel: {
			maxMembers: 100,
			allowFileUploads: true,
			allowImageUploads: true,
		}
	},

	// Notifications configuration
	notifications: {
		enabled: true,
		requestPermission: true,
		showBadges: true,
	},

	// Development configuration
	development: {
		// Test users for development
		testUsers: [
			{
				id: 'user1',
				name: 'Marco Rossi',
				role: 'user',
			},
			{
				id: 'user2', 
				name: 'Laura Bianchi',
				role: 'user',
			},
			{
				id: 'admin',
				name: 'Amministratore',
				role: 'admin',
			}
		],
		
		// Development token (DO NOT use in production)
		devToken: 'dev_token_placeholder',
		
		// Logs enabled in development
		enableLogs: process.env.NODE_ENV === 'development',
	}
}

// Validation of configuration
export const validateConfig = () => {
	const errors = []

	if (!streamChatConfig.apiKey || streamChatConfig.apiKey === 'your_stream_api_key_here') {
		errors.push('API Key of Stream Chat not configured')
	}

	if (errors.length > 0) {
		console.error('Errors in Stream Chat configuration:', errors)
		return false
	}

	return true
}

export default streamChatConfig

